package co.maytes.standupbot.dashboard.features.settings

import kotlinx.datetime.Instant
import kotlinx.datetime.TimeZone
import kotlinx.datetime.toLocalDateTime

object LogTimeFormat {
    private const val TWO_DIGITS = 2

    fun minutes(instant: Instant): String {
        val time = instant.toLocalDateTime(TimeZone.UTC)
        return "${time.date} ${pad(time.hour)}:${pad(time.minute)}"
    }

    fun seconds(instant: Instant): String {
        val time = instant.toLocalDateTime(TimeZone.UTC)
        return "${minutes(instant)}:${pad(time.second)}"
    }

    private fun pad(value: Int): String = value.toString().padStart(TWO_DIGITS, '0')
}
